module.exports = __webpack_public_path__ + "static/img/schedule_en.1b0c9d50.png";